module.exports = __webpack_public_path__ + "img/hibetter.1d8f2b8a.svg";